import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.join.js";
import React from 'react';
import { Fade, Grid, Box, Typography, GRAY } from '@applyboard/ui-components';
import StudentScore from "./StudentScore";
import { useIsMobile } from "../../../../../../useIsMobile";
import Row from "./Row";
var SubHeading = function SubHeading(_ref) {
  var expanded = _ref.expanded,
    content = _ref.content,
    _ref$accepted = _ref.accepted,
    accepted = _ref$accepted === void 0 ? false : _ref$accepted;
  var isMobile = useIsMobile();
  var appear = !expanded;
  if (!appear) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(Fade, {
    "in": appear,
    style: {
      transitionDelay: appear ? '100ms' : '0ms'
    }
  }, /*#__PURE__*/React.createElement(Row, {
    style: {
      top: '31px',
      color: "".concat(!accepted ? GRAY[15] : null),
      position: isMobile ? 'absolute' : null,
      paddingTop: isMobile ? '15px' : null
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, Array.isArray(content.req) ? content.req.join('; ') : content.req))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(StudentScore, {
    pass: content.pass,
    requiredScores: content.req
  }, content.student))));
};
export default SubHeading;